// 从一段可能包含说明文字的文本中提取第一个 HTTP/HTTPS 链接。
// 遇到中英文逗号、句号、分号、括号、引号等标点即停止匹配，并额外剥离末尾残留标点，
// 避免“https://.../abc123，提取码：1234”这类内容被整段当成网址。
// 保留 URL 内部合法字符（? & = # . - _ ~ 等）。
const TRAILING_URL_PUNCTUATION = /[，。；、！？：,;.!?()[\]{}<>"'“”‘’）】》」』]+$/;

export function extractFirstUrl(text: string): string | null {
  if (!text) return null;
  const match = text.match(/https?:\/\/[^\s<>，。；、！？：（）()【】《》"“”‘’,;]+/i);
  if (!match) return null;
  return match[0].replace(TRAILING_URL_PUNCTUATION, "");
}
